<template>
    <form @submit.prevent="save" class="">
    <div class="w-full md:py-3 md:pr-5 md:pl-12 p-5 border border-additional-text rounded-lg relative cursor-pointer" @click="toggleGameCard('open')">
      <!-- delete team modal -->
      <delete-team-alert-modal
          v-if="delete_team_alert_modals"
          :text="form.errors.first('team')"
          @close ="delete_team_alert_modals=false">
    </delete-team-alert-modal>

      <!-- new team header -->
            <div class=" mr-2 font-bold mb-3 flex items-center" v-if="newTeam">
              <p class="text-main-text text-2xl">Создание команды</p>
            </div>


            <div class="flex flex-col md:flex-row " >
              <div class="flex items-center">
                <!-- team picture -->
                <Avatar ref="avatar" :show="show" :team="team" :teamId="team.id" :avatar="team.avatar_url" :newTeam="newTeam" :key="team.id" @saveNewTeamAvatar="saveNewTeamAvatar" />

                <!-- team name -->
              <p v-if="!show" class="md:hidden font-bold mx-2 text-sm max-w-4/5 mb-4 truncate" style="overflow: hidden;
               width:400px">{{form.name}}</p>
              </div>


                <!-- user city mobile -->
                <div v-if="!newTeam" class="text-10px font-bold md:hidden" :class="[show?'ml-auto':'ml-12 -mt-4']">
                  <span>Город: </span>
                  <span class="text-brand-light">{{team.city}}</span>
                </div>


                <div class="w-full md:w-2/3 flex flex-col justify-start items-start md:ml-4 md:mt-4 relative sm:max-w-2/5">
                  <p class="label-for-input" v-if="inputClickable && show">Название команды</p>
                  <div class="w-full">
                    <input  type="text"
                            class="w-full md:w-3/5 pl-0 hidden text-main-text text-sm font-semibold outline-none md:flex focus:border-brand-light truncate"
                            :class="editableName || (inputClickable &&show) ? 'border-b border-menuOrder-gray-medium ':''"
                            id="teamNameField"
                            v-if="!newTeam"
                            @mouseover="inputClickable = true"
                            @mouseleave="inputClickable = false"
                            @click.prevent.stop="editName"
                            @blur="saveInfo"
                            :placeholder="form.name"
                            v-model ="form.name"/>
                    <moz-input v-else v-model="form.name" class="md:-mt-1 truncate" placeholder="Название команды" type="text"></moz-input>
                    <moz-input v-if="show && !newTeam" @blur="saveInfo" v-model="form.name" class="md:-mt-1 md:hidden w-full truncate" placeholder="Название команды" type="text">
                    </moz-input>

                    <span v-if="form.errors.has('name') && show"
                    class="text-red text-xs md:hidden" v-text="form.errors.first('name')"
                    ></span>

                  </div>


                  <!-- user city desktop -->
                  <div v-if="!newTeam" class="mr-auto text-sm font-bold hidden md:block my-3">
                    <span>Город: </span>
                    <span class="text-brand-light">{{team.city}}</span>
                  </div>

                  <!-- show team 'Капитан' : 'Участник' desktop -->
                  <div v-if="!newTeam" class="hidden md:block team-member-label" :class="amICaptain ? 'green-label' : 'yellow-label'">
                  {{amICaptain ? 'Капитан' : 'Участник'}}
                  </div>

                  <!-- create new team -->
                  <div  class="flex flex-row justify-center ml-1 mt-4" v-if="newTeam">

                            <p class="text-main-text text-xs md:text-sm  font-semibold whitespace-no-wrap">города:&nbsp;</p>
                            <!-- show city -->
                            <div>
                                 <p class=" text-brand-light text-xs md:text-sm font-semibold" v-if="team.city">{{team.city}}</p>
                                 <p class=" text-brand-light text-xs md:text-sm font-semibold underline      cursor-pointer" v-else @click.prevent="open_modal">{{selected_city}}</p>
                            </div>


                           <!-- city select -->
                            <div class="search-city max-w-xs overflow-y-hidden absolute w-64 -mt-2 -ml-1" v-if="show_city" v-on-clickaway="close_modal">
                                <input class="border-2 rounded h-8 w-full outline-none" :placeholder="team.city ? team.city :'Выберите ваш город'" v-model="searchKeyword">
                                <div class="border-2 rounded shadow-md mt-2 relative pin-t pin-l h-48 overflow-y-auto bg-white">
                                              <ul class="list-reset">
                                                <li v-for="(city, index) in cities" :key="index" class="options"><p class="p-2 block text-black hover:bg-brand-light hover:text-white cursor-pointer" @click.stop="setCity(city.name , city.id)">
                                                    {{city.name}}
                                                </p></li>
                                              </ul>
                              </div>
                            </div>
                    </div>

                </div>

                <div class="flex items-start w-full md:w-2/3 md:mt-4 mt-6" >

                 <!-- show team 'Капитан' : 'Участник' mobile -->
                <div v-if="!newTeam" class="team-member-label md:hidden absolute rounded-tr" style="top:-1px;right:-1px;" :class="amICaptain || newTeam ? 'green-label' : 'yellow-label'">
                    {{amICaptain || newTeam ? 'Капитан' : 'Участник'}}
                </div>

                    <div class="w-full md:mt-1 md:w-90%">
                        <div v-if="!newTeam" class="flex flex-row justify-center w-full lg:ml-2 xl:ml-12" :class="{'justify-around':show}" style="margin-top:-2px">


                            <div class="w-full">

                            <div class="flex" :class="{'justify-between':show}" >
                            <!-- team rank -->
                            <div :class="[{'w-full':!show},{'flex':show},{'pl-10 md:p-0':!teamIsChampion && !show}]">
                              <!--  team rank image-->
                              <img v-if="team.results.common.is_filled" :class="[show?'md:mx-0 -ml-1 md:-ml-1 md:h-full':'mx-auto']" class="block w-10 md:w-12 h-12" :src="require(`@/assets/icons/${team.results.common.rang}.svg`)" alt="">
                              <!-- team without rank -->
                              <img v-else :class="{'mx-auto':!show}" class="block w-10 md:w-12 h-12" src="@/assets/icons/Без ранга.svg" alt="">

                              <p v-if="team.results.common.is_filled && team.results.common.rang !='Без ранга'" :class="[show?'my-auto':'mx-auto h-8 grid-center text-center']"  class="font-bold text-10px lg:text-xs" >{{team.results.common.rang}}</p>

                              <!-- <p v-else :class="[show?'pt-0':'mx-auto h-8 grid-center text-center']"  class="font-bold text-10px lg:text-xs " >Ранг команды</p> -->

                              <p v-else :class="[show?'pt-0':'text-center mx-auto h-8']"  class="w-3/4 font-bold text-10px lg:text-xs grid-center text-center" >Ранг команды</p>
                            </div>

                            <!-- champions when team card open  -->
                            <div v-if="teamIsChampion && show" class="relative md:mr-0 w-1/2 md:w-1/3 flex md:block" >
                            <div class="grid-center ml-auto">
                             <img class="md:w-10 mx-auto block w-7" src="@/assets/icons/champion-icon-cabinet.png" alt="">
                            </div>
                            <p class="pt-4 text-center font-bold text-10px lg:text-xs h-full md:h-8 md:hidden ml-4 md:ml-0">Лига чемпионов</p>
                            </div>

                            </div>

                            <!-- progress bar desktop-->
                            <div  v-if="show" class="w-full relative hidden md:block">
                              <div class="flex">
                              <div class="point-progress-bar-outter w-2/3">
                                <div class="point-progress-bar-inner" :style="{'width': `${progress}%`}">
                                </div>
                              </div>
                               <p v-if="teamIsChampion" class="pt-4 h-8 text-center font-bold text-10px md:text-xs w-1/3">Лига чемпионов</p>
                              </div>
                              <div class="points-number mt-1 text-right w-2/3">
                                  <span v-if="team.results.common.is_filled" class="text-brand-light">{{userScoreSum}}</span>
                                  <span v-else class="text-brand-light">0</span>
                                  <span v-if="team.results.common.is_filled" class="text-additional-text">/{{userNextScore > 6000 ? 6000 : userNextScore}}</span>
                                  <span v-else class="text-additional-text">/0</span>
                              </div>
                            </div>

                            </div>


                            <!-- general point -->
                            <div class="w-full relative grid" v-if="!show" :class="{'pr-10 md:p-0':!teamIsChampion}">
                               <div>
                              <p class="text-xl text-center md:text-xl lg:text-2xl xl:text-28px text-brand-light font-bold h-12 grid-center">{{this.userScoreSum}}</p>
                              <p class="text-center font-bold text-10px lg:text-xs w-full h-8 grid-center">Общий балл</p>
                              </div>
                            </div>

                            <!-- champions when team card close  -->
                             <div v-if="teamIsChampion && !show" class="relative w-full" >
                            <div class="w-full grid-center" :class="[show?'':'h-12']">
                               <img class="md:w-10 mx-auto block w-7" src="@/assets/icons/champion-icon-cabinet.png" alt="">
                            </div>
                               <p class="md:absolute md:pin-b  grid-center text-center font-bold text-10px lg:text-xs pt-1 md:pt-0 w-full h-8">Лига чемпионов</p>
                            </div>
                            <div v-if="!teamIsChampion && !show" :class="[{'w-full':!show},{'md:mr-0 md:w-1/3':show}]" class="relative hidden md:block">
                            </div>


                                        <!-- city select mobile-->
                            <div class="search-city max-w-xs overflow-y-hidden absolute ml-4 -mt-1 w-48 sm:w-56 " v-if="show_city" v-on-clickaway="close_modal">
                                        <input class="border-2 rounded h-8 w-full outline-none" :placeholder="team.city ? team.city :'Выберите ваш город'" v-model="searchKeyword">
                                          <div class="border-2 rounded shadow-md mt-2 relative pin-t pin-l h-42 overflow-y-auto bg-white">
                                              <ul class="list-reset">
                                                <li v-for="(city, index) in cities" :key="index" class="options"><p class="p-2 block text-black hover:bg-brand-light hover:text-white cursor-pointer" @click.stop="setCity(city.name , city.id)">
                                          {{city.name}}
                                                </p>
                                                </li>
                                             </ul>
                                          </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- show team 'Капитан' : 'Участник' mobile and new Team only -->
                <div v-if="newTeam" class="team-member-label md:hidden rounded-tr mt-4" :class="amICaptain || newTeam ? 'green-label' : 'yellow-label'">
                    {{amICaptain || newTeam ? 'Капитан' : 'Участник'}}
                </div>


                        <!-- progress bar mobile-->
                          <div  v-if="show && !newTeam" class="w-full flex relative md:hidden">
                            <div class="point-progress-bar-outter w-6/7">
                              <div class="point-progress-bar-inner" :style="{'width': `${progress}%`}">
                              </div>
                            </div>
                            <div class="points-number ml-2">
                                <span v-if="team.results.common.is_filled" class="text-brand-light">{{userScoreSum}}</span>
                                <span v-else class="text-brand-light">0</span>
                                <span v-if="team.results.common.is_filled" class="text-additional-text">/{{userNextScore > 6000 ? 6000:userNextScore}}</span>
                                <span v-else class="text-additional-text">/0</span>
                            </div>
                          </div>
                    <!-- cross icon -->
                    <div class="absolute pin-r flex items-center" :class="[newTeam ? 'pin-t mr-2' : 'mt-2 md:mt-3 md:mr-6' , [newTeam && show ? 'mt-3 md:mt-0 lg:mt-3 ':'']]" @click="toggleGameCard('close')">

                    <font-awesome-icon
                    :icon="['far', 'trash-alt']"
                    v-if="show && !newTeam && amICaptain"
                    :disabled="form.processing"
                    class="my-auto md:flex justify-end cursor-pointer lg:ml-auto xl:ml-auto lg:mr-8 xl:mr-8 text-xl text-grey-dark hidden"
                    @click.prevent.stop="deleteConfirm = true">
                    </font-awesome-icon>

                    <font-awesome-icon
                            v-if="!newTeam"
                            :icon="['far', 'angle-down']"
                            size="2x"
                            :class="rotateArrow"
                            fixed-width
                            class="arrow text-menu-inactive-gray-light cursor-pointer w-4 h-4 md:w-8 md:h-6 lg:h-8 mr-4 md:-mr-3"
                            @click.prevent.stop="show = !show"
                    ></font-awesome-icon>

                    <!-- <font-awesome-icon
                            v-if="newTeam"
                            :icon="['fa', 'times']"
                            size="2x"
                            :class="rotateArrow"
                            fixed-width
                            class="arrow text-menu-inactive-gray-light cursor-pointer w-3 h-3 md:w-8 md:h-8 mr-5 md:mr-3"
                            @click.prevent.stop="deleteConfirm = true"
                    ></font-awesome-icon> -->

                    <font-awesome-icon
                     v-if="newTeam"
                     :icon="['fal', 'times']"
                     class="text-brand-grey-light cursor-pointer text-2xl w-10 mt-3 lg:mt-0 xl:mt-0"
                     @click.prevent.stop="deleteTeam">
                     </font-awesome-icon>

                </div>
            </div>
            <span v-if="form.errors.has('name')&&show"
                          class="text-red text-xs hidden md:inline" v-text="form.errors.first('name')"
                    ></span>


             <div v-if="show" >
              <div class="mt-10 md:mt-6 flex   md:w-7/10 lg:w-3/5 ">
                <div class="flex flex-row" v-if="!newTeam">
                    <p @click.stop="management = true; company = false" class="outline-none no-underline font-bold xl:text-lg text-main-text cursor-pointer" :class="management &&  team.company && amICaptain ? 'team-active-link' : ''">
                        Управление участниками ({{team.players_count}}/{{team.max_players_count}})
                    </p>
                </div>
                <div v-if="team.company && amICaptain" @click.stop="management = false; company = true" class="hidden md:flex flex-row ml-8" >
                    <p  class="outline-none no-underline font-bold xl:text-lg text-main-text cursor-pointer" :class="company ? 'team-active-link' : ''">
                        Доп. информация
                    </p>
                </div>
                 </div>
            </div>
            <div v-if="show && management">

             <TeamManage
             @leave="leaveConfirm = true"
             :teamId="team.id"
             ref="teamMember"
             class="mt-6"
             :amICaptain="amICaptain"
             :team="team"
             :newTeam="newTeam"
             @capChange="captainHasChanged = true"
              />

            </div>
            <div v-if="show && company ">
           <TeamCompany :spinner="spinner" :team="team" :show="show" @saveInfo="fillCompany" />
            </div>
            <div v-if="!newTeam && show" class="plain-line px-8 mt-10 md:hidden"></div>
                <div v-if="show" class="md:hidden flex flex-col items-start">

                   <p v-if="team.company" @click.stop="toCompany" class="bottom-card-option">Доп. информация</p>
                   <p @click.stop="deleteConfirm = true" v-if="amICaptain" class="bottom-card-option">Удалить команду</p>
             </div>
            <div @click.stop="save" v-if="newTeam" class="mt-20 md:mt-12 cursor-pointer bg-brand-light rounded-full py-3 text-center hover-up w-250 text-white font-bold">
              Создать команду
            </div>


    </div>
  <reg-modal v-if="leftModal" @close="updateUser">
            <div class="text-sm text-center font-bold">
                <p class="text-brand-light font-bold flex justify-center">  {{user.name}} <span class="font-bold" style="color:#333333">,</span></p>
                <div class="flex">
                  <p class="text-brand-light w-100"><span  style="color:#333333">Вы вышли из команды</span> {{team.name}}</p>
                  </div>

            </div>
   </reg-modal>
      <confirm-delete v-if="leaveConfirm" key="leave_modal"  @close="leaveConfirm = false" :reverseButtons="true"
                          @white_button="leaveConfirm = false " @yellow_button="leaveTeam"
                          :html="`Хотите выйти из команды <span class='text-brand-light' style='word-break: break-all'>${team.name}</span>?`"
                          :button_text_firs=" 'Отменить'" :button_text_second="'Выйти'"
                          class="z-100 flex absolute pin"></confirm-delete>
     <confirm-delete v-if="deleteConfirm" key="leave_modal"  @close="deleteConfirm = false" :reverseButtons="true"
                          @white_button="deleteConfirm = false " @yellow_button="deleteTeam"
                          :html="team.name ? `Хотите удалить команду <span class='text-brand-light' style='word-break: break-all'>${team.name}</span>?` : 'Вы точно не хотите создавать команду?'"
                          :button_text_firs=" 'Отменить'" :button_text_second="'Удалить'"
                          class="z-100 flex absolute pin"></confirm-delete>
    </form>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Form from 'form-backend-validation';
import client from '@/clients/player';
import Selectbox from '../../partners/selectbox';
import CityList from '../../stub/city_list';
import DeleteModal from '../../partners/events/order/delete-modal';
import DeleteTeamAlertModal from './delete-team-alert-modal';
import TeamManage from './team-management';
import TeamCompany from './team-company';
import ConfirmDelete from '@/views/partners/events/order/delete-modal.vue';
import regModal from '@/views/partners/current-registration/registration-layout/registration-modal.vue';
import Avatar from './team-avatar.vue';
import base from '@/clients/base';
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'team-item',
  mixins: [clickaway],
  components: {
    DeleteModal, Selectbox, CityList, DeleteTeamAlertModal, TeamManage, TeamCompany, Avatar, ConfirmDelete, regModal,
  },
  props: {
    team: {
      type: Object,
    },
    index: {
      type: Number,
    },
    cities: {
      type: Array,
    },
  },
  data() {
    return {
      searchKeyword: '',
      show: false,
      newTeam: false,
      delete_team_alert_modals: false,
      management: true,
      company: false,
      show_city: false,
      avatarPopper: false,
      selected_city: this.$store.getters.cityProps.city || 'Выберите город',
      leaveConfirm: false,
      leftModal: false,
      inputClickable: false,
      captainHasChanged: false,
      newTeamAvatar: '',
      deleteConfirm: false,
      form: new Form({
        name: '',
        player_count: '',
        city_id: this.$store.getters.cityProps.id,
        company_name: '',
        company_comment: '',
        company_files: [],

      }, {
        http: client,
      }),

      editableName: false,
      spinner: false,
    };
  },
  mounted() {
    this.popupItem = this.$el;
  },
  created() {
    setTimeout(() => this.form.populate(this.team), 100);

    if (this.team.id === undefined) {
      this.show = true;
      this.newTeam = true;
    }
    this.counter();
  },
  methods: {
    ...mapActions(['selectShowModal', 'addUserTeams', 'removeUserTeam', 'selectModalText', 'refreshUser']),
    counter() {
      if (this.form.player_count === null) {
        this.player_count_name = 'веберите кол-во игроком';
      }
      if (this.form.player_count % 10 === 1 && this.form.player_count !== 10) {
        this.player_count_name = 'игрок';
      }
      if (this.form.player_count % 10 > 1 && this.form.player_count % 10 < 5) {
        this.player_count_name = 'игрока';
      }
      if (this.form.player_count % 10 > 4 && this.form.player_count % 10 < 10) {
        this.player_count_name = 'игроков';
      }
      if (this.form.player_count === 10) {
        this.player_count_name = 'игроков';
      }
    },
    closePopper() {
      this.$refs.teamMember.closePopper();
    },
    toCompany() {
      this.$router.push({
        name: 'additional-info',
        params: {
          teamId: this.team.id,
          team: this.team,
        },
      });
    },
    saveNewTeamAvatar(file) {
      this.newTeamAvatar = file;
    },
    leaveTeam() {
      client.delete(`teams/${this.team.id}/leave`).then(() => {
        this.leaveConfirm = false;
        this.leftModal = true;
      });
    },
    updateUser() {
      this.refreshUser(client);
      this.leftModal = false;
    },
    save() {
      this.spinner = true;
      let request = null;
      if (this.newTeam) {
        request = this.form.post('/teams');
      } else {
        this.form.company_files = this.concatLogos;
        request = this.form.post(`/teams/${this.team.id}`);
      }
      request.then((response) => {
        if (this.newTeamAvatar) {
          this.uploadNewTeamAvatar(response.id);
        }
        this.updateUser();
        this.spinner = false;
        this.addUserTeams(response);
        this.show = false;
        setTimeout(() => this.$emit('saved'), 100);
        if (this.newTeam) {
          this.selectModalText('Команда добавлена');
        }
        if (!this.newTeam) {
          this.selectModalText('Изменения сохранены');
        }
        this.selectShowModal(true);
        this.newTeam = false;
      })
        .catch(() => {
          this.spinner = false;
        });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    uploadNewTeamAvatar(id) {
      const data = new FormData();
      data.append('avatar', this.newTeamAvatar);
      client.post(`/teams/${id}/avatar`, data).then((res) => {
        this.updateUser();
      });
    },
    fillCompany(name, comment, files) {
      this.form.company_name = name;
      this.form.company_comment = comment;
      this.form.company_files = files;
      this.saveInfo();
    },
    saveInfo() {
      this.spinner = true;
      this.form.post(`/teams/${this.team.id}`).then((resp) => {
        this.addUserTeams(resp);
        this.form.populate(resp);
        this.editableName = false;
      }).finally(() => {
        this.spinner = false;
      });
    },
    deleteTeam() {
      if (this.newTeam) {
        this.$emit('notSaved', { id: this.index });
        this.show = false;
        setTimeout(() => this.$emit('saved'), 100);
      }
      if (!this.newTeam) {
        this.form.delete(`/teams/${this.team.id}`)
          .then((response) => {
            this.removeUserTeam(this.team.id);
            this.selectModalText('Команда удалена');
            this.selectShowModal(true);
            this.show = false;
            setTimeout(() => this.$emit('saved'), 100);
          })
          .catch((err) => {
            this.delete_team_alert_modals = true;
          });
      }
    },
    toggleGameCard(option) {
      if (!this.newTeam && option == 'open') {
        this.show = true;
      } else if (!this.newTeam && option == 'close') {
        this.show = false;
      }
    },
    close_modal() {
      this.show_city = false;
    },
    open_modal() {
      this.show_city = true;
    },
    setCity(selected_city, city_id) {
      this.form.city_id = city_id;
      this.selected_city = selected_city;
      this.show_city = false;
    },
    searchingForCity() {
      const optionsList = document.querySelectorAll('.options');
      this.searchKeyword = this.searchKeyword.toLowerCase();
      const searchKeywordLength = this.searchKeyword.length;
      optionsList.forEach((option) => {
        let label = option.firstElementChild.innerText.toLowerCase();
        label = label.slice(0, searchKeywordLength);
        if (label.indexOf(this.searchKeyword) !== -1) {
          option.classList.add('block');
          option.classList.remove('hidden');
        } else {
          option.classList.add('hidden');
          option.classList.remove('block');
        }
      });
    },
    editName() {
      if (this.show && !this.newTeam && !this.editableName && this.amICaptain) {
        this.editableName = true;
      }
    },
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
    logosWidth() {
      /*  устанавливаем длину контейнера с логотипами */
      return (this.concatLogos.length + 1) * 110 > 550 ? 550 : (this.concatLogos.length + 1) * 110;
    },
    city_id() {
      return this.$store.getters.cityProps.id;
    },
    rotateArrow() {
      return !this.show ? '' : 'rotate-arrow';
    },

    amICaptain() {
      if (this.captainHasChanged) {
        return false;
      }
      if (this.team.captain) {
        return this.team.captain.id == this.user.id;
      }
    },
    teamIsChampion() {
      return this.team.results.league.is_filled && this.team.results.league.highlighted;
    },
    userScoreSum() {
      return Math.round(this.team.results.common.score_sum * 1e2) / 1e2;
    },
    userNextScore() {
      return (Math.round(this.team.results.common.score_to_next * 1e2) / 1e2) + Math.round(this.team.results.common.score_sum * 1e2) / 1e2;
    },
    progress() {
      return (this.userScoreSum / this.userNextScore) * 100;
    },

  },
  watch: {
    searchKeyword() {
      this.searchingForCity();
    },
  },
};
</script>

<style scoped>
    .arrow {
        transition: 0.5s all;
    }

    .rotate-arrow {
        transform: rotate(180deg);
    }


>>>.image-cont {
  position: relative;
  border-radius: 0.25rem;

  /* */
}
>>>.image {
    border-radius: 1rem;
    z-index: 0;
    border-radius: 0.25rem;
  }

  >>>.image-shadow {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.726);
    border-radius: 0.25rem;
    color: white;
    display: flex;
    font-size: 0.875rem;
    justify-content: center;
    align-items: center;
    opacity: 0;
  }

  >>>.image-shadow:hover {
      opacity: 1;
      color: transparent;
      cursor: pointer;
    }

  .upl>>>label {
    z-index: -1 !important;
    cursor: pointer;
  }
.width-custom {
    max-width: 80%;
  }
   .plain-line {
  height: 1px;
  background-color: #DADADA;
 }
  .w-250 {
    width: 250px;
    margin-left: auto;
  }
  >>>input {
    min-width: 20px;
  }

  >>>input:disabled {
    background: white;
  }
  >>>.team-member-label {
    width: 81px;
    text-align: center;
    @apply text-white font-bold py-1 px-3 text-10px rounded-sm

  }
  >>>.green-label {
    background-color: #00BD52;
  }
  >>>.yellow-label {
    background-color: #FFCE42;;
  }
  .team-active-link {
    padding-bottom: 2px;
    border-bottom: 2px solid #ffce42
  }

.spinner {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.option {
  width: 288px;
  @apply pl-5 py-2;
  background-color: white;
  z-index: 40;
}
.option:hover {
    @apply bg-brand-light text-white
}
.popper {
    position: absolute;
    top: 60px;
    right: -220px;
    border: 1px solid #DADADA;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1), 0px 2px 2px rgba(0, 0, 0, 0.1);
    z-index: 20;
}
.label-for-input {
  position: absolute;
  top: -14px;
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 12px;
  color: #979797;
  transition: all .5s ease;
}

.search-city{
  left: 5rem;
  z-index:10
}

.point-progress-bar-outter{
  height: 6px;
  background: #979797;
  border-radius: 3px;
  margin-top: 20px;
  position: relative;
}
.points-number{
  /* position: absolute;
  right:0; */
  margin-top: 14px;
  font-size: 12px;
  font-weight: 600;
}

.point-progress-bar-inner{
  background: #bd006c;
  height: 6px;
  position: absolute;
  border-radius: 3px;
  top: 0;
  left: 0;
}

@media (max-width:640px){
.search-city{
  left: 5.5rem;
  z-index:1000
}
}
@media (max-width: 840px) {
   .w-250 {
    width: 100%;
  }
  .max-w-250 {
    max-width: 190px;
  }
  .bottom-card-option {
    font-size: 10px;
line-height: 12px;
margin-top: 20px;
position: relative;
  }
  .bottom-card-option:after {
   content: '';
   position: absolute;
   bottom: 0px;
   width: 100%;
   z-index: 3;
   height: 1px;
   display: block;
   background-color: #333333;
  }
}
</style>
